import { IFileCreate } from 'types'
import * as yup from 'yup'
import { selectableRateTypeKeys } from '../constants'

const REQUIRED_MESSAGE = 'This field is required'

export enum CapacityType {
  range = 'range',
  single = 'single',
}

const transformNumber: yup.TransformFunction<yup.NumberSchema<number>> = (
  currentValue,
  originalValue
) => (currentValue === '' || originalValue === '' ? null : currentValue)

export const EditSourcedCarrierRateModalSchema = yup.object({
  capacityType: yup.string().oneOf(Object.values(CapacityType)).default(CapacityType.single),
  canDoWeekends: yup.boolean().required(REQUIRED_MESSAGE),
  carrierApplicationId: yup.string().required(REQUIRED_MESSAGE),
  confirmed: yup.boolean().required(REQUIRED_MESSAGE),
  laneAgreements: yup
    .array()
    .of(
      yup.object<IFileCreate>({
        file: yup.string().required(),
        fileFileName: yup.string().required(),
      })
    )
    .ensure()
    .max(1)
    .default([]),
  maxCapacity: yup.number().moreThan(0).transform(transformNumber).nullable().default(null),
  minCapacity: yup.number().transform(transformNumber).nullable().default(null),
  rate: yup
    .object({
      amount: yup.number().moreThan(0).required(),
      typeKey: yup.string().oneOf(selectableRateTypeKeys).required().default(''),
    })
    .required(),
})

export type TEditSourcedCarrierRateModalSchema = yup.InferType<
  typeof EditSourcedCarrierRateModalSchema
>
